module.exports = __webpack_public_path__ + "img/05-mobile.20784830.jpg";